import { useOutletContext } from 'react-router-dom'
import type { Event } from '@/types/database'

export interface EventContext {
  event: Event
  reloadEvent: () => void
}

/**
 * Access the parent event from any tab.
 *
 * Lives apart from EventLayout so that file exports only its component — React
 * Fast Refresh gives up on a module that mixes components with other exports.
 */
export function useEventContext(): EventContext {
  return useOutletContext<EventContext>()
}
